import React, { useState } from 'react';

const AnalyticsPage: React.FC = () => {
    const [dateRange, setDateRange] = useState('30d');
    const [selectedChatbot, setSelectedChatbot] = useState('all');

    // Mock-Daten für Chatbot-Auswahl
    const chatbots = [
        { id: 'all', name: 'Alle Chatbots' },
        { id: '1', name: 'Kundenservice Bot' },
        { id: '2', name: 'Produkt FAQ Bot' },
        { id: '3', name: 'Sales Assistent' },
    ];

    return (
        <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-6">Analytics</h1>

            <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 space-y-3 md:space-y-0">
                <div className="flex items-center">
                    <label htmlFor="chatbot-select" className="mr-2 text-sm font-medium text-gray-700">
                        Chatbot:
                    </label>
                    <select
                        id="chatbot-select"
                        className="border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                        value={selectedChatbot}
                        onChange={(e) => setSelectedChatbot(e.target.value)}
                    >
                        {chatbots.map(chatbot => (
                            <option key={chatbot.id} value={chatbot.id}>
                                {chatbot.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="flex space-x-2">
                    <button
                        onClick={() => setDateRange('7d')}
                        className={`px-3 py-1 text-sm font-medium rounded-md ${
                            dateRange === '7d'
                                ? 'bg-blue-100 text-blue-700'
                                : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                    >
                        7 Tage
                    </button>
                    <button
                        onClick={() => setDateRange('30d')}
                        className={`px-3 py-1 text-sm font-medium rounded-md ${
                            dateRange === '30d'
                                ? 'bg-blue-100 text-blue-700'
                                : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                    >
                        30 Tage
                    </button>
                    <button
                        onClick={() => setDateRange('90d')}
                        className={`px-3 py-1 text-sm font-medium rounded-md ${
                            dateRange === '90d'
                                ? 'bg-blue-100 text-blue-700'
                                : 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50'
                        }`}
                    >
                        90 Tage
                    </button>
                </div>
            </div>

            {/* Übersichtskarten */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Gespräche</h3>
                    <p className="mt-2 text-4xl font-semibold text-gray-900">2,543</p>
                    <div className="mt-1 flex items-center text-sm">
            <span className="text-green-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
              </svg>
              <span className="ml-1">12.3%</span>
            </span>
                        <span className="ml-2 text-gray-500">vs. vorheriger Zeitraum</span>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Erfolgsrate</h3>
                    <p className="mt-2 text-4xl font-semibold text-gray-900">87.4%</p>
                    <div className="mt-1 flex items-center text-sm">
            <span className="text-green-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
              </svg>
              <span className="ml-1">2.5%</span>
            </span>
                        <span className="ml-2 text-gray-500">vs. vorheriger Zeitraum</span>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Durchschn. Gesprächsdauer</h3>
                    <p className="mt-2 text-4xl font-semibold text-gray-900">4m 37s</p>
                    <div className="mt-1 flex items-center text-sm">
            <span className="text-red-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12 13a1 1 0 100 2h5a1 1 0 001-1V9a1 1 0 10-2 0v2.586l-4.293-4.293a1 1 0 00-1.414 0L8 9.586 3.707 5.293a1 1 0 00-1.414 1.414l5 5a1 1 0 001.414 0L11 9.414 14.586 13H12z" clipRule="evenodd" />
              </svg>
              <span className="ml-1">1.2%</span>
            </span>
                        <span className="ml-2 text-gray-500">vs. vorheriger Zeitraum</span>
                    </div>
                </div>

                <div className="bg-white p-6 rounded-lg shadow">
                    <h3 className="text-sm font-medium text-gray-500 uppercase tracking-wide">Aktivitätszeit</h3>
                    <p className="mt-2 text-4xl font-semibold text-gray-900">18.6h</p>
                    <div className="mt-1 flex items-center text-sm">
            <span className="text-green-600 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
              </svg>
              <span className="ml-1">8.7%</span>
            </span>
                        <span className="ml-2 text-gray-500">vs. vorheriger Zeitraum</span>
                    </div>
                </div>
            </div>

            {/* Diagramm */}
            <div className="bg-white p-6 rounded-lg shadow mb-6">
                <h2 className="text-lg font-medium text-gray-900 mb-4">Nutzung im Zeitverlauf</h2>
                <div className="h-80 flex items-center justify-center border border-dashed border-gray-300 rounded">
                    [Hier würde ein Diagramm mit Chart.js eingebunden werden]
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Top Anfragen */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">Top Anfragen</h2>
                    <div className="space-y-4">
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-700">Öffnungszeiten</span>
                                <span className="text-gray-500 text-sm">22%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div className="bg-blue-500 h-2 rounded-full" style={{ width: '22%' }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-700">Produktverfügbarkeit</span>
                                <span className="text-gray-500 text-sm">18%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div className="bg-blue-500 h-2 rounded-full" style={{ width: '18%' }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-700">Bestellstatus</span>
                                <span className="text-gray-500 text-sm">15%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div className="bg-blue-500 h-2 rounded-full" style={{ width: '15%' }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-700">Retourenabwicklung</span>
                                <span className="text-gray-500 text-sm">12%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div className="bg-blue-500 h-2 rounded-full" style={{ width: '12%' }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-700">Kontaktinformationen</span>
                                <span className="text-gray-500 text-sm">9%</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2">
                                <div className="bg-blue-500 h-2 rounded-full" style={{ width: '9%' }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Ungelöste Anfragen */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">Ungelöste Anfragen</h2>
                    <div className="divide-y divide-gray-200">
                        <div className="py-3">
                            <div className="flex justify-between">
                                <div>
                                    <p className="font-medium text-gray-800">Rücksendung Status</p>
                                    <p className="text-sm text-gray-500">12 Vorkommen</p>
                                </div>
                                <button className="text-blue-500 text-sm hover:text-blue-700">Details</button>
                            </div>
                        </div>
                        <div className="py-3">
                            <div className="flex justify-between">
                                <div>
                                    <p className="font-medium text-gray-800">Rabattcode eingeben</p>
                                    <p className="text-sm text-gray-500">9 Vorkommen</p>
                                </div>
                                <button className="text-blue-500 text-sm hover:text-blue-700">Details</button>
                            </div>
                        </div>
                        <div className="py-3">
                            <div className="flex justify-between">
                                <div>
                                    <p className="font-medium text-gray-800">Lieferzeit ändern</p>
                                    <p className="text-sm text-gray-500">8 Vorkommen</p>
                                </div>
                                <button className="text-blue-500 text-sm hover:text-blue-700">Details</button>
                            </div>
                        </div>
                        <div className="py-3">
                            <div className="flex justify-between">
                                <div>
                                    <p className="font-medium text-gray-800">Ersatzteile bestellen</p>
                                    <p className="text-sm text-gray-500">7 Vorkommen</p>
                                </div>
                                <button className="text-blue-500 text-sm hover:text-blue-700">Details</button>
                            </div>
                        </div>
                        <div className="py-3">
                            <div className="flex justify-between">
                                <div>
                                    <p className="font-medium text-gray-800">Internationale Lieferung</p>
                                    <p className="text-sm text-gray-500">6 Vorkommen</p>
                                </div>
                                <button className="text-blue-500 text-sm hover:text-blue-700">Details</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Nutzerzufriedenheit */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">Nutzerzufriedenheit</h2>
                    <div className="flex items-center justify-around mb-6">
                        <div className="text-center">
                            <div className="text-3xl font-bold text-green-500 mb-1">76%</div>
                            <div className="text-sm text-gray-500">Positiv</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-bold text-gray-400 mb-1">17%</div>
                            <div className="text-sm text-gray-500">Neutral</div>
                        </div>
                        <div className="text-center">
                            <div className="text-3xl font-bold text-red-500 mb-1">7%</div>
                            <div className="text-sm text-gray-500">Negativ</div>
                        </div>
                    </div>
                    <div className="h-48 flex items-center justify-center border border-dashed border-gray-300 rounded">
                        [Hier würde ein Tortendiagramm eingebunden werden]
                    </div>
                </div>

                {/* Gesprächsverlauf */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-medium text-gray-900 mb-4">Gesprächsverlauf</h2>
                    <div className="mb-4">
                        <div className="flex justify-between text-sm mb-2">
                            <span className="text-gray-500">Gesprächsstart zu Lösung</span>
                            <span className="font-medium">3 Frage(n) im Durchschnitt</span>
                        </div>
                        <div className="h-40 flex items-center justify-center border border-dashed border-gray-300 rounded">
                            [Hier würde ein Flussdiagramm eingebunden werden]
                        </div>
                    </div>
                    <div>
                        <h3 className="font-medium text-gray-800 mb-2">Tipps zur Optimierung</h3>
                        <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                            <li>Füge weitere Informationen zum Thema Rücksendungen hinzu</li>
                            <li>Erkläre den Rabattcode-Prozess klarer</li>
                            <li>Verbessere die Informationen zu Liefermöglichkeiten</li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Export Buttons */}
            <div className="mt-6 flex justify-end space-x-3">
                <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
                    CSV exportieren
                </button>
                <button className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
                    PDF exportieren
                </button>
            </div>
        </div>
    );
};

export default AnalyticsPage;